import LICITACION_PARTICIPANTES from '@/graphql/querys/administracion/licitaciones/participantes/licitacionParticipantes.gql';
import LICITACION from '@/graphql/querys/administracion/licitaciones/licitacion.gql';
import AGREGAR_LICITACION_APERTURA_PROPUESTA from '@/graphql/mutations/administracion/licitaciones/aperturapropuestas/agregarLicitacionAperturaPropuesta.gql';
import ACTUALIZAR_LITICATION_APERTURA_PROPUESTA from '@/graphql/mutations/administracion/licitaciones/aperturapropuestas/actualizarLicitacionAperturaPropuesta.gql';

export default {
  apollo: {
    licitacion: {
      query: LICITACION,
      variables() {
        return {
          id: this.participanteLicitacion.idLicitacion,
        };
      },
      update({ licitacion }) {
        this.propuestasObras = licitacion.obras.map((obra) => ({
          ...obra,
          importe: 0,
          porcentajeIva: 0,
          iva: 0,
          total: 0,
        }));
      },
    },
  },
  methods: {
    async mixAgregarLicitacionAperturaPropuesta() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo.mutate({
        mutation: AGREGAR_LICITACION_APERTURA_PROPUESTA,
        variables: {
          aperturaPropuesta: this.licitacionAperturaPropuesta,
        },
        update: (store, { data: { agregarLicitacionAperturaPropuesta } }) => {
          const data = store.readQuery({
            query: LICITACION_PARTICIPANTES,
            variables: {
              idLicitacion: this.$route.params.idLicitacion,
            },
          });
          data.licitacionParticipantes
            .find((participanteLicitacion) => participanteLicitacion.id
          === agregarLicitacionAperturaPropuesta.idParticipante)
            .aperturaPropuestas = agregarLicitacionAperturaPropuesta;
          store.writeQuery({ query: LICITACION_PARTICIPANTES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarLicitacionAperturaPropuesta() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_LITICATION_APERTURA_PROPUESTA,
        variables: {
          idParticipante: this.participanteLicitacion.aperturaPropuestas.idParticipante,
          aperturaPropuesta: this.licitacionAperturaPropuesta,
        },
        update: (store, { data: { actualizarLicitacionAperturaPropuesta } }) => {
          const data = store.readQuery({
            query: LICITACION_PARTICIPANTES,
            variables: {
              idLicitacion: this.$route.params.idLicitacion,
            },
          });
          data.licitacionParticipantes
            .find((participanteLicitacion) => participanteLicitacion.id
          === actualizarLicitacionAperturaPropuesta.idParticipante)
            .aperturaPropuestas = actualizarLicitacionAperturaPropuesta;
          store.writeQuery({ query: LICITACION_PARTICIPANTES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
